import React from 'react';
import { MapPin, Phone, Video } from 'lucide-react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { AppointmentCaseManagerSelect } from './CaseAppointmentFields';

// Shared appointment fields: Case Appointments "Schedule" and the Edit form on Case Appointments + Management Calendar.
export const AppointmentFormFields = ({ value, onChange, appointmentTypes, staffList, onTypeChange, idPrefix = 'case-appointment' }) => {
  const set = (patch) => onChange(patch);
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-title`}>Title *</Label>
        <Input id={`${idPrefix}-title`} placeholder="Appointment title" value={value.title || ''} onChange={(e) => set({ title: e.target.value })} data-testid={`${idPrefix}-title-input`} />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Type</Label>
          <Select value={value.appointment_type} onValueChange={onTypeChange || ((v) => set({ appointment_type: v }))}>
            <SelectTrigger data-testid={`${idPrefix}-type-select`}><SelectValue placeholder="Select type" /></SelectTrigger>
            <SelectContent>{appointmentTypes.map((t) => <SelectItem key={t.id} value={t.id}>{t.label || t.name}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label>Location Type</Label>
          <Select value={value.location_type} onValueChange={(v) => set({ location_type: v })}>
            <SelectTrigger data-testid={`${idPrefix}-location-type-select`}><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="in_person"><div className="flex items-center gap-2"><MapPin className="w-4 h-4" /> In Person</div></SelectItem>
              <SelectItem value="phone"><div className="flex items-center gap-2"><Phone className="w-4 h-4" /> Phone Call</div></SelectItem>
              <SelectItem value="video"><div className="flex items-center gap-2"><Video className="w-4 h-4" /> Video Call</div></SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2"><Label>Date *</Label><Input type="date" value={value.date || ''} onChange={(e) => set({ date: e.target.value })} data-testid={`${idPrefix}-date-input`} /></div>
        <div className="space-y-2"><Label>Start Time *</Label><Input type="time" value={value.start_time || ''} onChange={(e) => set({ start_time: e.target.value })} data-testid={`${idPrefix}-start-input`} /></div>
        <div className="space-y-2"><Label>End Time</Label><Input type="time" value={value.end_time || ''} onChange={(e) => set({ end_time: e.target.value })} data-testid={`${idPrefix}-end-input`} /></div>
      </div>
      <div className="space-y-2">
        <Label>Location / Meeting Link</Label>
        <Input placeholder={value.location_type === 'video' ? 'Teams/Zoom link' : 'Address or room'} value={value.location || ''} onChange={(e) => set({ location: e.target.value })} data-testid={`${idPrefix}-location-input`} />
      </div>
      <div className="space-y-2">
        <Label>Notes</Label>
        <Textarea placeholder="Additional notes..." value={value.notes || ''} onChange={(e) => set({ notes: e.target.value })} rows={2} data-testid={`${idPrefix}-notes-input`} />
      </div>
      <div className="space-y-2">
        <Label>Case Manager</Label>
        <AppointmentCaseManagerSelect value={value.case_manager_id} staffList={staffList} onChange={(v) => set({ case_manager_id: v })} testId={`${idPrefix}-case-manager-select`} />
        <p className="text-xs text-muted-foreground">Defaults to the case's assigned case manager.</p>
      </div>
    </>
  );
};
